import _ from 'lodash';

const initInvitedMembers = (members, allItems) => {
    return _.filter(allItems, item =>
        _.some(members, member => Number(item.id) === Number(member.id)));
};

export default initInvitedMembers;
